import React, { Fragment, useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import propTypes from 'prop-types';
import apiFetch from '@wordpress/api-fetch';
import Dropdown from 'react-accessible-dropdown';
import 'react-accessible-dropdown/style.css';
import './topicSelect.scss';

const TopicSelect = ({ title }) => {
  const [topicPages, setTopicPages] = useState([]);
  const openTopic = (id) => {
    // eslint-disable-next-line max-len
    const { link } = topicPages.filter((page) => page.id === parseInt(id, 0))[0];
    if (link && (window.location.href !== link)) {
      const newLink = link.replace('/topic/', '/topics/');
      window.location.href = newLink;
    }
  };

  useEffect(() => {
    apiFetch({
      // get taxonomy topics
      path: '/wp-json/wp/v2/topic?per_page=100',
    })
      .then((response) => {
        const filteredResponse =
        response.filter((topic) => topic.title.rendered !== title);
        setTopicPages(filteredResponse);
      });
  }, []);

  return (
    <Fragment>
      <div className="Dropdown-root">
        <Dropdown
          options={topicPages.map((page) => page.title.rendered)}
          onChange={(selectedOption) => {
            const selectedId =
            0 < topicPages.length ?
              topicPages.filter((page) =>
                page.title.rendered === selectedOption.value)[0].id : null;
            openTopic(selectedId);
          }}
          value={title}
        />
      </div>
    </Fragment>

  );
};
TopicSelect.propTypes = {
  title: propTypes.string.isRequired,
};

const appElement = document.querySelector('.topic-select');
if (appElement) {
  ReactDOM.render(
    <TopicSelect
      title={appElement.dataset.title}
    />,
    appElement,
  );
}
